import React from "react";
import { language } from "language/default";
const quartileRanking = [
    { className: "bottom", label: language.en.widgets.quartileRanking.bottom },
    { className: "lowerMid", label: language.en.widgets.quartileRanking.lowerMid },
    { className: "upperMid", label: language.en.widgets.quartileRanking.upperMid },
    { className: "top", label: language.en.widgets.quartileRanking.top }
];
const quartileRankingWithUnknown = [
    { className: "", label: language.en.widgets.quartileRanking.unknownn },
    { className: "bottom", label: language.en.widgets.quartileRanking.bottom },
    { className: "lowerMid", label: language.en.widgets.quartileRanking.lowerMid },
    { className: "upperMid", label: language.en.widgets.quartileRanking.upperMid },
    { className: "top", label: language.en.widgets.quartileRanking.top }
];
export const getBenchmarkQuartileCellClass = (value) => (value && value > 0 ? `insQuartileRanking ${quartileRanking[value - 1].className}` : "");
export const BenchmarkQuartileRenderer = (props) => React.createElement("span", { className: "insQuartileRankingContent" }, quartileRanking[props?.value - 1]?.label || "");
export const benchmarkQuartileRankingValueFormatter = (props) => quartileRanking[props?.value - 1]?.label;
export const benchmarkQuartileRankingWithUnknownValueFormatter = (props) => quartileRankingWithUnknown[props?.value]?.label;
